var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProfileNoimage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0C13.44 0 0 13.44 0 30C0 46.56 13.44 60 30 60C46.56 60 60 46.56 60 30C60 13.44 46.56 0 30 0ZM30 12C35.79 12 40.5 16.71 40.5 22.5C40.5 28.29 35.79 33 30 33C24.21 33 19.5 28.29 19.5 22.5C19.5 16.71 24.21 12 30 12ZM30 54C23.91 54 16.71 51.54 11.58 45.36C16.65 41.4 23.04 39 30 39C36.96 39 43.35 41.4 48.42 45.36C43.29 51.54 36.09 54 30 54Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileNoimage);
export default __webpack_public_path__ + "static/media/icon-profile-noimage.daea9e3ab10f971934e02a64e0088a63.svg";
export { ForwardRef as ReactComponent };